// extracted by mini-css-extract-plugin
export default {"popper":"EmojiPicker_popper__kWE5t"};